import styles from './SCarDetaiSecondImageSection.module.scss';

const SCarDetaiSecondImageSection = ({ secondImageSectionData }) => {
  // 添加安全检查，防止secondImageSectionData为undefined时的解构错误
  if (!secondImageSectionData) {
    return (
      <div className={styles.container} data-aos="fade-up">
        <p>No second image data available.</p>
      </div>
    );
  }

  const { image, title, subtitle, buttonUrl, buttonText } = secondImageSectionData;

  // 获取图片URL
  const getImageUrl = () => {
    if (!image?.fields) return '';

    const desktopImage = image.fields.desktopImage?.value?.src;
    const mobileImage = image.fields.mobileImage?.value?.src;
    const tabletImage = image.fields.tabletImage?.value?.src;

    return desktopImage || tabletImage || mobileImage || '';
  };

  const imageUrl = getImageUrl();

  return (
    <div className={styles.container} data-aos="fade-up">
      <div className={styles.wrapper}>
        {imageUrl && (
          <img src={imageUrl} alt="HeroSection background" className={styles.backgroundImage} />
        )}
        <div className={styles.container}>
          <div>
            {title && <h1 className={styles.title}>{title}</h1>}
            {subtitle && (
              <div className={styles.subtitle} dangerouslySetInnerHTML={{ __html: subtitle }} />
            )}
          </div>
          {buttonUrl && buttonText && (
            <a className={styles.pcButton} href={buttonUrl}>
              {buttonText}
            </a>
          )}
        </div>
      </div>
      {buttonUrl && buttonText && (
        <a className={styles.laptopButton} href={buttonUrl}>
          {buttonText}
        </a>
      )}
    </div>
  );
};

export default SCarDetaiSecondImageSection;
